import PropTypes from 'prop-types'
import React from 'react'
import { SemanticToastContainer } from 'react-semantic-toasts'
import { css } from 'emotion'
import { setSharedState, sharedState } from '../../utilities/sharedState';

const toastContainerStyle = {
  position: 'fixed',
  top: 5,
  right: 10,
  zIndex: 100000
}

export default class MainLayout extends React.Component {

  static propTypes = {
    header: PropTypes.func.isRequired,
    sidePanel: PropTypes.func.isRequired,
    content: PropTypes.func.isRequired
  }

  constructor(props, ctx) {
    super(props, ctx)
    this.state = {
      collapseSidepanel: sharedState.collapseSidepanel,
      sidePanelWidth: 220,
    }
  }

  handleToggleNavPanel = () => {
    this.setState(state => ({
      ...state,
      collapseSidepanel: !state.collapseSidepanel,
    }), () => {
      setSharedState({
        collapseSidepanel: this.state.collapseSidepanel
      })
    })
  }

  // triggerClickToResizeGrid = () => {
  //   window.dispatchEvent(new Event('resize'));
  //   const girdElement = document.getElementsByClassName('react-grid-Grid');
  //   if (girdElement.length) {
  //     girdElement[0].click();
  //     const canvas = document.getElementsByClassName('react-grid-Canvas');
  //     canvas[0].scrollTo(canvas[0].scrollX, canvas[0].scrollY);
  //   }
  // }

  render() {
    const sidePanelClasses = [
      'sidepanel',
      this.state.collapseSidepanel ? 'collapsed' : '',
    ].join(' ')

    const contentClasses = [
      'content',
      this.state.collapseSidepanel ? 'expanded' : '',
    ].join(' ')

    return (
      <React.Fragment>
        <div style={toastContainerStyle} >
          <SemanticToastContainer />
        </div>

        {/*
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {this.props.header(this.toggleSidepanel)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={this.state.sidePanelWidth}>
              {this.state.collapseSidepanel ? '' : this.props.sidePanel()}
            </Grid.Column>
            <Grid.Column width={this.state.contentWidth}>
              {this.props.content()}
            </Grid.Column>
            <Grid.Column width={2} />
          </Grid.Row>
        </Grid>
        */}

        {/* <div className={style}>
          <div className='header'>header</div>
          <div className='body'>
            <div className='sidepanel'>sidepanel</div>
            <div className='content'>content</div>
          </div>
        </div> */}

        <div className={style}>
          <div className='header'>
            {this.props.header(this.handleToggleNavPanel)}
          </div>
          <div className='body'>
            <div className={sidePanelClasses}>
              {this.props.sidePanel(this.state.collapseSidepanel)}
            </div>
            <div className={contentClasses}>
              {this.props.content()}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const style = css`
  & {
    & > .header {
      top: 0px;
      left: 0px;
      height: 50px;
      width: 100%;
      position: fixed;
      z-index: 1021;
    }

    & > .body {
      margin-top: 50px;

      & > .sidepanel {
        margin-left: 0;
        position: fixed;
        z-index: 1019;
        width: 240px;
        height: 100vh;
        padding-top: 5px;
        padding-left: 5px;
        padding-right: 5px;
        background-color: #e9ebec;
        border-right: 1px solid #dbdee0;
  
        &.collapsed {
          width: 70px;
        }
      }

      & > .content {
        display: block;
        margin-left: 240px;
        margin-top: 20px;
        margin-right: 5px;
  
        &.expanded {
          margin-left: 70px;
        }
      }
    }
    
  }
`


// WEBPACK FOOTER //
// ./components/layout/MainLayout.js